export default __webpack_public_path__ + "static/media/mobile_menu.c7ef2906.svg";